import { defineComponent as _defineComponent } from 'vue'

import { MetaInfo } from 'vue-meta/types/vue-meta';

const __default__ = {
	// eslint-disable-next-line vue/multi-word-component-names
	name: 'Popular',
	metaInfo() {
		return (this as unknown as { head: MetaInfo }).head;
	},
};

import AdUnit from '@/components/AdUnit.vue';
import GuideFeatured from '@/components/editorial/GuideFeatured.vue';
import GuideItem from '@/components/editorial/GuideItem.vue';
import PaginationNav from '@/components/nav/PaginationNav.vue';

import { usePagination } from '@/helpers/composables/usePagination';
import { useArticleList } from '@/helpers/composables/useArticleList';
import { useRoute } from 'vue-router/composables';
import { useI18n } from '@/helpers/composables/useI18n';

import { makeRssMetaInfo } from '@/routing/editorial';

import { ClickGuideItemLink, clickGuideItemLink } from '@/pages/editorial/tracking';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose }) {

const pageSize = 50;
const FEATURED_AMOUNT = 4 as const;

// how many ad breaks to include in the article list for pages > 1
const adFrequency = 1;

const { currentPage, isFirstPage } = usePagination();
const { articles, lastPage, totalCount } = useArticleList({ pageSize, page: currentPage });

function trackContentClick(event: { label: string; property: ClickGuideItemLink['property'] }, value: number) {
	clickGuideItemLink({ property: event.property, label: event.label, value });
}

const route = useRoute();
const { t } = useI18n();

const head = computed<MetaInfo>(() => {
	const page = +route.query?.page;
	const isOnPage = !Number.isNaN(page) && page > 1;

	const title = (isOnPage ? t('WEBAPP_GUIDE_META_TITLE_PAGED', { page }) : t('WEBAPP_GUIDE_META_TITLE')).toString();

	const description = (
		isOnPage ? t('WEBAPP_GUIDE_META_DESCRIPTION_PAGED', { page }) : t('WEBAPP_GUIDE_META_DESCRIPTION')
	).toString();

	const canonicalPath = `https://www.${JW_CONFIG.DOMAIN}${route.fullPath}`;

	const { meta, link } = makeRssMetaInfo();

	return {
		title,
		link: [{ vmid: 'canonical', rel: 'canonical', href: canonicalPath }, ...link],
		meta: [
			{ vmid: 'description', name: 'description', content: description },
			{ vmid: 'og:title', property: 'og:title', content: title },
			{ vmid: 'og:description', property: 'og:description', content: description },
			...meta,
		],
	};
});

expose({ head });

return { __sfc: true,pageSize, FEATURED_AMOUNT, adFrequency, currentPage, isFirstPage, articles, lastPage, totalCount, trackContentClick, route, t, head, AdUnit, GuideFeatured, GuideItem, PaginationNav }
}

})